(() => {
  const mapNode = document.querySelector('[data-legacy-variant-map]');
  const productNode = mapNode?.closest('[data-product-root]')?.querySelector('[data-product-json]');
  if (!mapNode || !productNode) return;
  try {
    const url = new URL(location.href);
    const requested = url.searchParams.get('variant');
    const replacement = JSON.parse(mapNode.textContent)[requested];
    const product = JSON.parse(productNode.textContent);
    if (!replacement || String(replacement) === requested || !product.variants.some(variant => String(variant.id) === String(replacement))) return;
    url.searchParams.set('variant', replacement);
    location.replace(url.href);
  } catch (_) {
    // Preserve Shopify's native variant selection if merchant data is invalid.
  }
})();
